export { default as ModalEmailDetail } from './ModalEmailDetail';
export { default as ModalCreateEmail } from './ModalCreateEmail';